import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import PressKit from "@/pages/PressKit";
import Apps from "@/pages/Apps";
import MenuViewer from "@/pages/MenuViewer";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/press" element={<PressKit />} />
        <Route path="/apps" element={<Apps />} />
        <Route path="/menu/:brandId" element={<MenuViewer />} />
      </Routes>
    </BrowserRouter>
  );
}
